import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from "../../../_virtual/_rollupPluginBabelHelpers.js";
import 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import useStores from "../../../hooks/useStores.js";
import ResizeHandle from "./ResizeHandle.js";
import { fieldPlaceholderProps } from "../fieldUtils.js";

var DrawableSignatureField = function DrawableSignatureField(_ref) {
  var _assignmentStore$opti, _assignmentStore$defa;

  var selected = _ref.selected,
      field = _ref.field,
      rest = _objectWithoutProperties(_ref, ["selected", "field"]);

  var _useStores = useStores(),
      assignmentStore = _useStores.assignmentStore;

  var x = field.x,
      y = field.y,
      width = field.width,
      height = field.height;
  var label = (_assignmentStore$opti = assignmentStore.options.find(function (option) {
    return option.assignmentKey === field.data.assignedTo;
  })) === null || _assignmentStore$opti === void 0 ? void 0 : _assignmentStore$opti.label;
  var isDefaultAssignmentType = field.data.assignedTo === ((_assignmentStore$defa = assignmentStore.defaultOption) === null || _assignmentStore$defa === void 0 ? void 0 : _assignmentStore$defa.assignmentKey);
  var fieldPlaceholder = '';

  if (field.data.valueType === 'signature') {
    fieldPlaceholder = "*".concat(label, " Signs Here");
  } else if (field.data.valueType === 'initials') {
    fieldPlaceholder = "*".concat(label, " Initials Here");
  } else if (field.data.valueType === 'date') {
    fieldPlaceholder = '*Date Signed';
  }

  return jsx("g", rest, jsx("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    className: classnames({
      'bg-primary': isDefaultAssignmentType,
      'border-primary': isDefaultAssignmentType && selected,
      'bg-info': !isDefaultAssignmentType,
      'border-info': !isDefaultAssignmentType && selected
    }),
    fillOpacity: isDefaultAssignmentType ? '0.25' : '0.75'
  }), jsx(ResizeHandle, {
    field: field
  }), jsx("foreignObject", _extends({}, fieldPlaceholderProps(field), {
    // Reduce width so it doesn't overlay the resize handle.
    width: fieldPlaceholderProps(field).width - 18
  }), jsx("text", null, fieldPlaceholder)));
};

DrawableSignatureField.displayName = "DrawableSignatureField";
var DrawableSignatureField$1 = observer(DrawableSignatureField);
export default DrawableSignatureField$1;